module.exports = __webpack_public_path__ + "img/chr_ts_7_penlight.95b795ca.png";